import { render, staticRenderFns } from "./NoContactManager.vue?vue&type=template&id=2b128700&scoped=true&"
import script from "./NoContactManager.vue?vue&type=script&lang=js&"
export * from "./NoContactManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b128700",
  null
  
)

export default component.exports